import { render, staticRenderFns } from "./PaymentVisitsModal.vue?vue&type=template&id=f763907c"
import script from "./PaymentVisitsModal.vue?vue&type=script&lang=js"
export * from "./PaymentVisitsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports